import api from './api'
import { toastError, toastSuccess } from './toast'
import { handleError } from './handle-error'

export const loadTenants = () => {
  const response = new Promise((resolve, reject) => {
    api.get(`tenants`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(null)
        toastError(handleError(error))
      });
  })
  return response
}

export const updateTenant = data => {
  const response = new Promise((resolve, reject) => {
    api.put(`tenants/${data.id}`, data)
      .then(response => {
        resolve(response.data)
        toastSuccess('Registro atualizado!')
      })
      .catch(error => {
        reject(null)
        toastError(handleError(error))
      })
  })
  return response
}

export const loadTenantById = id => {
  const response = new Promise((resolve, reject) => {
    api.get(`tenants/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(null)
        toastError(handleError(error))
      })
  })
  return response
}
